<!-- =========================================================================================
	File Name: Error500.vue
	Description: 500 Page
	----------------------------------------------------------------------------------------
	Item Name: Vuesax Admin - VueJS Dashboard Admin Template
	Version: 1.1
	Author: Pixinvent
	Author URL: hhttp://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
	<div class="h-screen flex w-full bg-img">
		<div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto text-center">
			<img src="../../assets/images/pages/500.png" alt="graphic-500" class="mx-auto mb-4 responsive">
			<h1 class="mb-12 text-5xl">Internal Server Error!</h1>
			<p class="mb-16">susceptive nonturbinated indoctrination formulary dyskinetic deafforest Strumella frolicsomeness encrustment portia myelination lachrymatory bestain hoople piscator pyramidoidal parter clipt.</p>
			<vs-button size="large" to="/">Back to Home</vs-button>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
            value1: ''
		}
	}
}
</script>